import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconGuidanceTov = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <path
        d="M5.69233 10.5519H4.30771C3.69567 10.5519 3.10869 10.3088 2.67591 9.87603C2.24313 9.44325 2 8.85627 2 8.24423C2 7.63219 2.24313 7.04521 2.67591 6.61244C3.10869 6.17966 3.69567 5.93652 4.30771 5.93652H5.69233V10.5519Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.69336 10.5517C8.40177 10.5519 11.0496 11.3535 13.3033 12.8557L14.0011 13.3209V3.16699L13.3033 3.63223C11.0496 5.13435 8.40177 5.93601 5.69336 5.93624V10.5517Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.69336 10.5518C5.69297 11.156 5.81552 11.7541 6.05355 12.3095C6.29159 12.8649 6.64013 13.3661 7.07798 13.7825"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconGuidanceTov.displayName = 'IconGuidanceTov';
